import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=19f7e80d&scoped=true&"
import script from "./studentList.vue?vue&type=script&lang=js&"
export * from "./studentList.vue?vue&type=script&lang=js&"
import style0 from "./studentList.vue?vue&type=style&index=0&id=19f7e80d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f7e80d",
  null
  
)

export default component.exports